import { render } from "./Role_add.vue?vue&type=template&id=90456886"
import script from "./Role_add.vue?vue&type=script&lang=js"
export * from "./Role_add.vue?vue&type=script&lang=js"
script.render = render

export default script